































import { Component, Vue, Prop } from 'nuxt-property-decorator';
import { Anonymous, Public, WarRoomPostCommentSearchResult } from '~/types/graphql';
import { htmlHighlightedText } from '~/utils/textHighlight';
import Avatar from '@/components/common/Avatar/Avatar.vue';

@Component({
  name: 'UniversalSearchResultsPostComments',
  components: {
    Avatar,
  },
})
export default class UniversalSearchResultsPostComments extends Vue {
  @Prop({ type: Object, required: true }) comment!: WarRoomPostCommentSearchResult;

  get isPublicCommenter() {
    return this.comment.record.author.__typename === 'Public';
  }

  get htmlText() {
    return htmlHighlightedText(this.comment.highlightedText);
  }

  get authorTitle() {
    if (this.isPublicCommenter) {
      return `${(this.comment.record.author as Public).firstname} ${
        (this.comment.record.author as Public).lastname
      }`.trim();
    }

    return (this.comment.record.author as Anonymous).username;
  }
}
